export default __webpack_public_path__ + "static/media/Richard_Phan_-_Resume.24dde1fd.pdf";